import React from 'react';
import PropTypes, { arrayOf, shape } from 'prop-types';
import { Heading, Paragraph, Link } from 'components/common';
import {
  sortArticlesByDate,
  filterArticlesByYear,
} from './PressPageUtility';
import NoPressContent from './NoPressContent';
import { formatDate } from '../../helpers/DateFormatUtil';

import './PressReleaseContent.scss';

const PressReleaseContent = ({ content, yearFilter, nothingToShow }) => {
  const filterArticles = filterArticlesByYear(content, yearFilter);
  const sortArticles = sortArticlesByDate(filterArticles);

  return (
    <div className="press-release-content">
      <ul className="article-list">
        {sortArticles.length === 0 ? <NoPressContent text={nothingToShow} />
          : sortArticles
            .map((val, idx) => (
              // eslint-disable-next-line
              <li key={idx}>
                <div className="date-wrapper">
                  <Paragraph>{formatDate(val.date)}</Paragraph>
                </div>
                <Link
                  to={val.link}
                  rel="noopener noreferrer"
                  className="article-title"
                >
                  <Heading primary as="h3">{val.title}</Heading>
                </Link>
              </li>
            ))
        }
      </ul>
    </div>
  );
};

PressReleaseContent.propTypes = {
  content: arrayOf(shape({
    link: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
  })),
  yearFilter: PropTypes.string,
  nothingToShow: PropTypes.string,
};

PressReleaseContent.defaultProps = {
  content: null,
  yearFilter: null,
  nothingToShow: null,
};

export default PressReleaseContent;
